var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.333 12.5H59.9999L51.6574 4.15751C49.4091 1.90917 46.3916 0.666672 43.2558 0.666672H12.6666C6.09909 0.666672 0.892419 5.9325 0.892419 12.5L0.833252 83.5C0.833252 90.0675 6.09909 95.3333 12.6666 95.3333H107.333C113.842 95.3333 119.167 90.0083 119.167 83.5V24.3333C119.167 17.825 113.842 12.5 107.333 12.5ZM95.4999 59.8333H83.6666V71.6667C83.6666 74.9208 81.0041 77.5833 77.7499 77.5833C74.4958 77.5833 71.8333 74.9208 71.8333 71.6667V59.8333H59.9999C56.7458 59.8333 54.0833 57.1708 54.0833 53.9167C54.0833 50.6625 56.7458 48 59.9999 48H71.8333V36.1667C71.8333 32.9125 74.4958 30.25 77.7499 30.25C81.0041 30.25 83.6666 32.9125 83.6666 36.1667V48H95.4999C98.7541 48 101.417 50.6625 101.417 53.9167C101.417 57.1708 98.7541 59.8333 95.4999 59.8333Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.e2517753474b6df603b7ae096cb8b98c.svg";
export { ForwardRef as ReactComponent };